import { useCallback } from 'react';
import jwtDecode from 'jwt-decode';
import useAuth from './useAuth';
import { useRefreshTokens } from '../services/auth/authServices';

const useSitePermissionUpdate = () => {
  const { auth, accessibleSiteIds, setAccessibleSiteIds } = useAuth();
  const refresh = useRefreshTokens();

  // Get the current user's username from the JWT token
  const getCurrentUsername = useCallback(() => {
    if (auth?.accessToken) {
      try {
        const decoded = jwtDecode(auth.accessToken);
        return decoded.username || decoded.sub || decoded.email;
      } catch {
        return null;
      }
    }
    return null;
  }, [auth]);

  const handleSiteAssignment = useCallback(async (siteIds) => {
    const sitesToAdd = Array.isArray(siteIds) ? siteIds : [siteIds];

    // Add new sites to accessible sites
    const updatedSiteIds = [...new Set([...accessibleSiteIds, ...sitesToAdd])];
    setAccessibleSiteIds(updatedSiteIds);

    // Force token refresh to get updated site IDs
    await refresh(true);
  }, [accessibleSiteIds, setAccessibleSiteIds]);

  const handleSiteUnassignment = useCallback(async (siteIds) => {
    const sitesToRemove = Array.isArray(siteIds) ? siteIds : [siteIds];

    // Remove sites from accessible sites
    const updatedSiteIds = accessibleSiteIds.filter(
      (siteId) => !sitesToRemove.includes(siteId),
    );
    setAccessibleSiteIds(updatedSiteIds);

    // Force token refresh to get updated site IDs
    await refresh(true);
  }, [accessibleSiteIds, setAccessibleSiteIds]);

  return {
    handleSiteAssignment,
    handleSiteUnassignment,
    getCurrentUsername,
  };
};

export default useSitePermissionUpdate;
